import React, {Fragment} from "react";
import {Form, FormListener} from "../form/Form";
import {AttributeType, UserAttributeDefinition, UserWriteAccess} from "../../http/protocol";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Submit} from "../form/Submit";
import {getContainer} from "../../ioc/IOCSetup";
import {RouteComponentProps, withRouter} from "react-router";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {LoadingViewState, RouterView} from "../RouterView";
import {Validators} from "../form/Validators";
import {UserAttributeService} from "../../services/UserAttributeService";
import {SelectInput} from "../form/SelectInput";
import {Case, Switch} from "../form/Switch";

interface State extends LoadingViewState {
    userAttribute? : UserAttributeDefinition;
    validationMap? : any;
}

interface Props extends RouteComponentProps {

}

export class UserAttributeView extends RouterView<Props,State> implements FormListener<UserAttributeDefinition>{

    service : UserAttributeService;
    constructor(props : Props){
        super(props);
        this.service = getContainer().getUserAttributeService();

        this.state = { userAttribute : {}, validationMap : {}, loading : true};
    }

    loadContent() : Promise<any> | undefined {
        var id = (this.props.match.params as any).id;
        if(id && id!== "new") {
            return this.service.getEntity(id).then((a : UserAttributeDefinition) => {
                this.setState({ userAttribute : a});
            })
        } else {
            return undefined;
        }

    }
    componentDidUpdate(prevProps : RouteComponentProps, prevState : any) {
        if((this.props.match.params as any).id !== (prevProps.match.params as any).id) {
            this.refreshContent();
        } else {
            super.componentDidUpdate(prevProps, prevState);
        }
    }

    onSubmit():Promise<any> {
        if(!this.state.userAttribute) {
           return Promise.reject("Unable to save attribute");
        }
        return this.service.save(this.state.userAttribute).then( (a : UserAttributeDefinition) => {
            if((this.props.match.params as any).id === "new") {
                this.navigate("/user-attribute/" + a.id);
            } else {
                this.setState({ userAttribute : a });
            }

        }).catch(err=>{
            throw Error("Unable to create/save user");
        });
    }

    onSubmitError(){}

    formDidUpdate(formModel:UserAttributeDefinition, validationMap : any) {
        this.setState({ userAttribute : formModel, validationMap : validationMap});
    }


    getTitle() : string {
        return "Edit/Create User Attribute";
    }



    renderContent() {
        if(!this.state.userAttribute) {
            return <span></span>
        }
        return (

            <Fragment>
                    <Form className="form-horizontal" formListener={this} modelObject={this.state.userAttribute} validationMap={this.state.validationMap}>
                        <div className={"card"}>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <FormSubmitError />
                                        <FormSubmitSuccess text="User Attribute was updated successfully"/>

                                        <FormGroup className="form-group mb-3" model="attributeKey">
                                            <label>Attribute Key</label>
                                            <FormInput className="form-control" model="attributeKey" type="text" validators={[Validators.required()]}/>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group mb-3" model="type">
                                            <label>Attribute Type</label>
                                            <SelectInput values={[AttributeType.SYSTEM_INTERNAL, AttributeType.SYSTEM, AttributeType.PRIVATE, AttributeType.PUBLIC]} className="form-control" model="type" type="text" validators={[Validators.required()]}/>
                                            <span className={"help-block"}>
                                                 <Switch value={this.state.userAttribute.type}>
                                                     <Case value={AttributeType.SYSTEM_INTERNAL}>
                                                        This is an internal attribute that is not shown to the user and will not be sent to any external system (analyitcs, providers etc)
                                                     </Case>
                                                      <Case value={AttributeType.SYSTEM}>
                                                       This is an internal attribute that is not shown to the user and may be sent to external systems (analyitcs, providers etc)
                                                     </Case>
                                                     <Case value={AttributeType.PRIVATE}>
                                                        This is an attribute the user may be able to see himself (Example First Name). It may also be sent to external systems
                                                     </Case>
                                                     <Case value={AttributeType.PUBLIC}>
                                                         This is an attribute any user may be able to see (example screen name). It may also be sent to external systems
                                                     </Case>
                                                 </Switch>
                                            </span>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group mb-3" model="userWriteAccess">
                                            <label>User Write Access</label>
                                            <SelectInput values={[UserWriteAccess.NONE, UserWriteAccess.CREATE, UserWriteAccess.CREATE_AND_UPDATE]} className="form-control" model="userWriteAccess" type="text" validators={[Validators.required()]}/>
                                            <span className={"help-block"}>
                                                 <Switch value={this.state.userAttribute.userWriteAccess}>
                                                     <Case value={UserWriteAccess.NONE}>
                                                         The user will NOT be able to set this attribute himself (usually a system attribute)
                                                     </Case>
                                                      <Case value={UserWriteAccess.CREATE_AND_UPDATE}>
                                                         The user will be able to set and update this attribute himself
                                                     </Case>
                                                      <Case value={UserWriteAccess.CREATE}>
                                                         The user will be able to set this attribute but not update it after it has been set
                                                     </Case>
                                                 </Switch>
                                            </span>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>

                                        <div className="custom-control custom-checkbox" >
                                            <FormInput model="required" id="required" className={"custom-control-input fm-blocked"} type="checkbox" />
                                            <label className={"custom-control-label"} htmlFor={"required"}>
                                                If this attribute is required when the user created
                                            </label>

                                        </div>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group mb-3" model="defaultValue">
                                            <label>Default value</label>
                                            <FormInput className="form-control" model="defaultValue" type="text" />
                                            <span className={"help-block"}>OPTIONAL. Value that will be added to the user during registration if the attribute is not present in the registration request. The value will be validated on the backend when the defintion is updated.</span>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group mb-3" model="options">
                                            <label>Selectable Values</label>
                                            <FormInput className="form-control" model="options" type="text" />
                                            <span className={"help-block"}>OPTIONAL. Comma-separated list of acceptable values. If set then a dropdown will be displayed to the user instead of a text input. Example: HSCB,JPMorgan,Bank of China,Citigroup</span>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group mb-3" model="minLength">
                                            <label>Min Length</label>
                                            <FormInput className="form-control" model="minLength" type="integer" />
                                            <span className={"help-block"}>The minimum length this attribute can have, if empty no minimum limit is enforced</span>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group mb-3" model="maxLength">
                                            <label>Max Length</label>
                                            <FormInput className="form-control" model="maxLength" type="integer" />
                                            <span className={"help-block"}>The maximum length this attribute can have, if empty 255 characters is max length</span>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group mb-3" model="regex">
                                            <label>Regex validation</label>
                                            <FormInput className="form-control" model="regex" type="integer" validators={[Validators.strLength(0,255)]}/>
                                            <span className={"help-block"}>Optional regex for validating this attribute, Example alpha numeric value: <strong>^[a-zA-Z0-9].*$</strong></span>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group mb-3" model="nameTranslationKey">
                                            <label>Name Translation Key</label>
                                            <FormInput className="form-control" model="nameTranslationKey" type="text"/>
                                            <span className={"help-block"}>OPTIONAL. Name for the input field. We recommend prefixing with user.attributes. Example: <strong>user.attributes.birth-year</strong></span>
                                        </FormGroup>

                                        <FormGroup className="form-group mb-3" model="descriptionTranslationKey">
                                            <label>Description Translation Key</label>
                                            <FormInput className="form-control" model="descriptionTranslationKey" type="text"/>
                                            <span className={"help-block"}>OPTIONAL. Contextual help text for user when entering the data. We recommend prefixing with user.attributes. Example: <strong>user.attributes.birth-year-description</strong></span>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className={"card"}>
                            <div className={"card-body"}>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="ibox float-e-margins">
                                            <div className="ibox-content">
                                                <div className="ibox-title">
                                                    <h5>Actions</h5>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-10 col-sm-offset-2">
                                                        <Submit className="btn btn-primary waves-effect waves-light">Save User Attribute</Submit>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Form>


            </Fragment>
        )
    }

}

export default withRouter(UserAttributeView);